import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Our Works', path: '/our-works' },
    { name: 'Bathroom Offers', path: '/bathroom-offers' },
    { name: 'Complex Heating', path: '/complex-heating' },
    { name: 'Special Offers', path: '/special-offers' },
    { name: 'Testimonials', path: '/testimonials' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img
              src="https://static.readdy.ai/image/2b8febc409be403949093d91f25c447f/0f35813a97286f31d3228ef67b80045c.png"
              alt="Smart Heatplumb Limited"
              className="h-12 w-12 object-contain"
            />
            <span
              className={`font-serif font-bold text-lg transition-colors ${
                isScrolled ? 'text-primary' : 'text-white'
              }`}
            >
              Smart Heatplumb
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === link.path
                    ? isScrolled
                      ? 'text-accent'
                      : 'text-white font-semibold drop-shadow-lg'
                    : isScrolled
                    ? 'text-gray-700 hover:text-accent'
                    : 'text-white/95 hover:text-white drop-shadow-md'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* WhatsApp Button */}
          <a
            href="https://wa.me/353873719751"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden lg:flex items-center space-x-2 bg-accent hover:bg-accent-dark text-white px-5 py-2.5 rounded-full transition-colors whitespace-nowrap shadow-lg"
          >
            <i className="ri-whatsapp-line text-lg"></i>
            <span className="text-sm font-medium">+353 87 371 9751</span>
          </a>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2"
            aria-label="Toggle menu"
          >
            <i
              className={`text-2xl ${
                isScrolled ? 'text-primary' : 'text-white drop-shadow-lg'
              } ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}
            ></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <div className="px-4 py-4 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.path
                    ? 'bg-accent text-white'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <a
              href="https://wa.me/353873719751"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center space-x-2 bg-accent text-white px-4 py-3 rounded-lg whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              <span className="text-sm font-medium">+353 87 371 9751</span>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;